import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import { FPButtonMenu } from 'UI/components/molecules';

import { useBulkEmailSequencesPreviewItemStyles } from './BulkEmailSequencesPreviewItem.styles';

const { sequences: sequencesCopies } = strings.bulkEmails.preview;
const { sent: sentCopies } = strings.bulkEmails.content;

export const BulkEmailSequencesPreviewItem = ({
  children,
  isLastElement,
  onOpenEditStepDrawer,
  onOpenStatsDrawer,
  sectionKey,
  shouldEnableMenuButton,
  shouldEnableStatsButton
}) => {
  const classes = useBulkEmailSequencesPreviewItemStyles();

  return (
    <>
      <Grid container item data-testid={`${sectionKey}-meta-row`}>
        <Grid
          container
          item
          alignItems="center"
          justify="space-between"
          className={classes.sectionTitleContainer}
        >
          <Grid item>
            <Typography variant="overline">
              {sequencesCopies.titles[sectionKey] ||
                strings.formatString(sequencesCopies.titles.default, {
                  attempt: sectionKey,
                  days: 4 // TODO: need to set days from back response
                })}
            </Typography>
          </Grid>
          <Grid item>
            <FPActionButton
              disabled={!shouldEnableStatsButton}
              size="small"
              variant="contained"
              text={sentCopies.bulkStatsButton}
              onClick={onOpenStatsDrawer}
              className={classes.statsButton}
            />
            <FPButtonMenu
              disabled={!shouldEnableMenuButton}
              isIconButton
              menuItems={[
                {
                  title: sequencesCopies.actions.edit,
                  action: onOpenEditStepDrawer,
                  visible: true
                },
                {
                  title: sequencesCopies.actions.stopSequence,
                  // TODO: add stop sequence action
                  action: () => {},
                  visible: true
                }
              ]}
            />
          </Grid>
        </Grid>
        {children}
      </Grid>
      <When condition={isLastElement}>
        <Divider className={classes.divider} />
      </When>
    </>
  );
};
